import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1 0 14 14" {...props}>
    <path
      d="M5 2.4c2.761 0 5 2.149 5 4.8S7.761 12 5 12 0 9.851 0 7.2s2.239-4.8 5-4.8zm0 1.2c-2.071 0-3.75 1.612-3.75 3.6S2.929 10.8 5 10.8c2.071 0 3.75-1.612 3.75-3.6S7.071 3.6 5 3.6zM4.75 5c.385 0 .702.257.745.589l.005.078v1.682l1.028.365c.385.137.572.525.418.867-.143.317-.53.483-.892.396l-.083-.025-1.5-.533a.684.684 0 01-.465-.538L4 7.8V5.667C4 5.298 4.336 5 4.75 5zm.9-5a.6.6 0 010 1.2H3.725a.6.6 0 010-1.2H5.65z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);

const IconChronometer = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconChronometer;
